import React from "react"
import styled from "styled-components"
import { minWidth, maxWidth } from "utils"

export const PodcastGridWrapper = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

export const PodcastRailHeader = ({ title }) => (
  <HeaderContainer>
    <h2>{title}</h2>
  </HeaderContainer>
)

const HeaderContainer = styled.div`
  margin-top: 1.2rem;
  margin-bottom: 2.2rem;
  width: 100%;
  border-top: 1px solid #12233f;
  padding-top: 4rem;

  ${minWidth.tablet`
    padding-bottom: 2rem;
    margin-bottom: 3rem;
  `}

  ${minWidth.desktop`
    margin: 0;
    padding-bottom: 2rem;
    justify-content: flex-start;
    width: 100%;
  `}

  h2 {
    color: #2260b2;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 1px;
    text-transform: uppercase;

    ${minWidth.mobile`
      font-size: 1.4rem;
    `}

    ${minWidth.desktop`
      font-size: 1.4rem;
    `}
  }

  ${minWidth.desktop`
    margin-top: 0;
    padding-top: 0;
    border-top: none;
  `}
`

export const PodcastContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  gap: 1.8rem;
  border-top: none;
  border-bottom: 1px solid #12233f;
  overflow-x: auto;
  padding: 0 0 4rem 0;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  ${minWidth.tablet`
    padding: 2rem 0 4rem 0;
  `}

  ${minWidth.desktop`
    flex-direction: column;
    gap: 1rem;
    overflow-x: visible;
    overflow-y: auto;
    justify-content: flex-start;
    border-top: 1px solid #12233f;
    padding: 2.6rem 0 2rem 0;
    max-height: 52rem;
    scrollbar-width: thin;
    -ms-overflow-style: scrollbar;

    &::-webkit-scrollbar {
      display: block;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 3px;
    }
  `}
`

export const PodcastCardContainer = styled.div`
  flex-shrink: 0;
  width: 26.5rem;
  height: 10.9rem;

  ${minWidth.mobileM`
    width: 28rem;
    height: 10.9rem;
  `}

  ${minWidth.tablet`
    width: 28.5rem;
    height: 10.9rem;
  `}

  ${minWidth.desktop`
    width: 100%;
    height: 12.1rem;
  `}
`

export const PodcastRailCard = ({ component }) => {
  const { headlineCard, image, url, durationInSeconds } = component
  const imageUrl = image?.[0]?.secure_url
  const durationInMinutes = durationInSeconds ? Math.round(durationInSeconds / 60) : null

  return (
    <CardLink href={url} target="_blank" rel="noopener noreferrer">
      <ImageContainer>{imageUrl && <img src={imageUrl} alt={headlineCard} />}</ImageContainer>

      <ContentContainer>
        <Title>{headlineCard}</Title>
        <Duration>{durationInMinutes ? `${durationInMinutes} min` : "xx min"}</Duration>
      </ContentContainer>
    </CardLink>
  )
}

const CardLink = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1.8rem;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s ease;
  align-items: flex-start;
  background-color: #fff;
`

const ImageContainer = styled.div`
  flex-shrink: 0;
  width: 11.2rem;
  height: 11.2rem;
  position: relative;
  overflow: hidden;
  border-radius: 1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  ${minWidth.tablet`
    width: 9rem;
    height: 9rem;
  `}

  ${minWidth.desktop`
    width: 11.2rem;
    height: 11.2rem;
  `}
`

const ContentContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  padding-top: 1rem;

  ${maxWidth.mobile`
    height: 100%;
  `}
`

const Title = styled.h3`
  font-size: 1.4rem;
  font-weight: 400;
  color: #333;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 0.3rem;
  display: -webkit-box;

  ${minWidth.tablet`
    font-size: 1.6rem;
  `}

  ${minWidth.desktop`
    font-size: 1.9rem;
  `}
`

const Duration = styled.p`
  font-size: 0.9rem;
  color: #888;
  font-weight: 400;
  margin: 0;

  ${minWidth.tablet`
    font-size: 1rem;
  `}

  ${minWidth.desktop`
    font-size: 1.1rem;
  `}
`
